export enum TerminalorderType {
	TAKE_AWAY = 'take_away',
	INSIDE = 'inside'
}
